import React from 'react';
import FlowRendererComponent from 'conversie-flow-bundle/assets/js/components/flow/renderers/FlowRendererComponent';
import ConversionFieldSelect from "../fields/ConversionFieldSelect";
import ConversionFieldDatePicker from "../fields/ConversionFieldDatePicker";
import ConversionFieldChoiceExpanded from "../fields/ConversionFieldChoiceExpanded";

export default function ConversionFlowComponentRenderer({ flow, id = 'form' }) {
    return (
        <FlowRendererComponent
            components={flow?.form?.components}
            path={`form.components`}
            id={`${ id }-${ flow?.flowId }.components`}
            renderField={(field, props) => {
                // console.log(field, props)
                if (field.type === 'choice-dropdown') {
                    return <ConversionFieldSelect {...props} />;
                }
                if (field.type === 'date') {
                    return <ConversionFieldDatePicker {...props} />;
                }
                if (field.type === 'choice-radio' && field.view === 'expanded') {
                    return (
                        <>
                            <ConversionFieldChoiceExpanded {...props} />
                            {['time'].includes(field.name) ?
                                <hr className="mb-0 mt-10 text--10 opacity-10 flow__hr"></hr>
                                : null}
                        </>
                    );
                }
            }}
        />
    );
}
